import styled from 'styled-components';

/*
 * Styles.
 */

/* This is used purely for styling child expression cards */
export const RuleExpressionCardsWrapper = styled.div``;
